<template>
  <HelperViewStatus
    class="order-error"
    data-testid="order-error"
    generic-error
    button-label="Tentar novamente"
    @click="emitOnRetry"
  />
</template>

<script lang="ts">
import { Component, Emit, Vue } from 'vue-property-decorator';

import { HelperViewStatus } from '@warrenbrasil/nebraska-web';

@Component({
  components: {
    HelperViewStatus
  }
})
export default class OrderError extends Vue {
  @Emit('on-retry')
  emitOnRetry() {}
}
</script>

<style lang="less" scoped>
.order-error {
  padding: 0 @size-spacing-x600 @size-spacing-x400 @size-spacing-x600;
  margin: 0 auto;
}
</style>
